/*
Abstractions for API requests
Base class

This class provides:
- The url to be requested (for use as the key for caching in vuex store)
- Method for making the request and returning the data asynchronously
  - This data returned by API should be in JSON form for direct storage into vuex store cache
*/

import axios from 'axios'

export default class ApiBase {
  constructor (params) { this.params = params }
  get url () { return '' }
  async getData () {
    const response = await axios.get(this.url)
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/api/base.js